<template>
  <a-modal
    :title="record ? '编辑群组' : '新建群组'"
    okText="保存"
    @ok="save"
    v-model="visible"
    destroyOnClose
    :confirmLoading="loading"
  >
    <a-form :form="form">
      <a-form-item v-bind="formItemLayout" label="群名">
        <a-input
          placeholder="请填写群名,限15个字"
          v-decorator="[
            'name',
            {
              rules: [
                { required: true, message: '请填写群名' },
                { max: 15, message: '限15个字' }
              ]
            }
          ]"
        ></a-input>
      </a-form-item>
      <a-form-item v-bind="formItemLayout" label="群类型">
        <a-radio-group
          v-decorator="[
            'type',
            { rules: [{ required: true, message: '请选择群类型' }] }
          ]"
        >
          <a-radio value="IE_POST">IE做单群（可关联职位）</a-radio>
          <a-radio value="NOT_IE_POST">非IE做单群（不可关联职位）</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item v-bind="formItemLayout" label="群公告">
        <a-textarea :rows="3" v-decorator="['notification']" />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import Api from "@/api";
import BaseModal from "@/components/base-modal.vue";
import ImgBind from "@/shared/utils/imgBind";
export default {
  name: "editGroupModal",
  extends: BaseModal,
  data() {
    return {
      form: this.$form.createForm(this),
      formItemLayout: {
        labelCol: { span: 5 },
        wrapperCol: { span: 18 }
      },
      record: undefined
    };
  },
  methods: {
    save() {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          this.loading = true;
          try {
            if (this.record) {
              console.log("编辑群");
              let response = await Api.im.editGroup({
                group_id: this.record.id,
                ...values
              });
            } else {
              let { id: group_id } = await Api.im.createGroup({ ...values });
              //创建群头像
              let source = new ImgBind([""]);
              source.loadImage().then(face_url => {
                console.log("youle", face_url.length);
                Api.im.updateGroupAvatar({ group_id, face_url });
              });
            }
            this.$emit("ok");
          } catch (e) {
            console.log("group edit err", e);
          }
          this.close();
        }
      });
    },
    show(record) {
      this.visible = true;
      this.record = undefined;
      if (record) {
        this.record = record;
        this.$nextTick().then(() => {
          this.form.setFieldsValue({
            name: record.name,
            type: record.type,
            notification: record.notification
          });
        });
      }
    }
  }
};
</script>

<style scoped lang="scss"></style>
